module.exports = __webpack_public_path__ + "static/img/Add_doctor_to_Fav.1b8d01b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Add_doctor_to_Fav.jpg
// module id = lC01
// module chunks = 0